import _ from 'lodash';

export default function hasItemMeasure(item, typeName) {
  return !!_.head((item.ItemMeasureList.ItemMeasure || []).filter((measure) => measure.ItemMeasureTypeNameEn === typeName));
}
